import {Alert} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

const PREFIX = 'view.payouts.create.details';

/** Explains that Tax Authority payouts have no bank details on the voucher and are executed manually. */
export function TaxAuthorityManualPaymentNotice() {
  const {t} = useTranslation('trustAccounts');

  return (
    <Alert
      variant="warning"
      title={t(`${PREFIX}.manualPaymentNoticeTitle`)}
      description={t(`${PREFIX}.manualPaymentNoticeIntro`)}
      descriptionColor="secondary"
    />
  );
}
